import { Face } from "./face";
import { Favorite } from "./favorite";
import { Fingerprint } from "./fingerprint";
import { Fireplace } from "./fireplace";
import { Flag } from "./flag";
import { Flight } from "./flight";
import { FollowTheSigns } from "./follow_the_signs";
import { FormatPaint } from "./format_paint";
import { Forum } from "./forum";

const iconsList = [
  { label: "Face", code: <Face /> },
  { label: "Favorite", code: <Favorite /> },
  { label: "Fingerprint", code: <Fingerprint /> },
  { label: "Fireplace", code: <Fireplace /> },
  { label: "Flag", code: <Flag /> },
  { label: "Flight", code: <Flight /> },
  { label: "FollowTheSigns", code: <FollowTheSigns /> },
  { label: "FormatPaint", code: <FormatPaint /> },
  { label: "Forum", code: <Forum /> },
];

export {
  iconsList,
  Face,
  Favorite,
  Fingerprint,
  Fireplace,
  Flag,
  Flight,
  FollowTheSigns,
  FormatPaint,
  Forum,
};
